
/* eslint-disable */
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { BsFiletypePdf } from "react-icons/bs";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import {
    getAdvertisementTypeDropdownValues,
    getGrievanceList,
    getGrievanceTypeDropdownValues,
    getSubGrievanceTypeDropdown,
    handlePdfView
} from "../../../common/actions/commonActions";
import commonLabels from "../../../common/labels/common_en.json";
import commonHILabels from "../../../common/labels/common_hi.json";
import { formatToDDMMYYYY_HHMMSS } from "../../../helpers/Datetime";
import '../../../styles/profile.css';
import { handleSendRemark } from "../actions/masterManagementAction";
const pdfDoc = process.env.PUBLIC_URL + "/images/document.pdf";


const GrievanceResponseForm = ({ setGrievanceResponse, grievanceResponse, listCurrentPage, setListCurrentPage }) => {

    const { register, control, watch, errors, handleSubmit, reset, setValue } = useForm({
        mode: "onChange"
    });
    let {
        mobileOTPResponse,
        advertisementDropdown,
        sub_grievance_type_list
    } = useSelector((state) => state.common, shallowEqual);
    let sessionData = JSON.parse(sessionStorage.getItem('session'));
    const userEmail = sessionData.emailId;
    const userMobile = sessionData.mobileNumber;
    const [reloadItem, setReloadItem] = useState(0);
    const [email, setEmail] = useState(userEmail);
    const [mobile, setMobile] = useState(userMobile);
    const [type, setType] = useState('');
    const [advtType, setAdvtType] = useState('');
    const [grievSubType, setGrievSubType] = useState('');
    const [description, setDescription] = useState('');
    const [remarks, setRemarks] = useState('');

    const [photo, setPhoto] = useState("");
    const [grievancePhoto, setGrievancePhoto] = useState({
        showGrievancePhoto: "",
        sendGrievancePhotoFile: "",
        showGrievancePhotoBase64: ""
    });
    const [pdf_error_message, setPdf_error_message] = useState(false)
    const [pdf_size, setPdf_size] = useState(false)
    const [pdf_sign, setPdf_sign] = useState(false)
    const [wordCount, setWordCount] = useState(0);
    const [limitReached, setLimitReached] = useState(false);
    const [currentPage, setCurrentPage] = useState(listCurrentPage);

    const [fileName, setFileName] = useState("No file chosen");
    const { grievanceList, singleGrievanceDetail } = useSelector((state) => state.masterManagementReducer, shallowEqual)

    const grievanceTypes = useSelector((state) => state.common.grievanceTypes);


    useEffect(() => {
        setReloadItem(reloadItem);
    }, [reloadItem]);

    const dispatch = useDispatch();
    useEffect(() => {
        // dispatch(getGrievanceList(userMobile));
        dispatch(getAdvertisementTypeDropdownValues())
        dispatch(getSubGrievanceTypeDropdown(type))
        setRemarks(singleGrievanceDetail.remarks)
        dispatch(getGrievanceTypeDropdownValues())

    }, [type, singleGrievanceDetail]);

    const clearGrievance = () => {
        setType('');
        setAdvtType('');
        setGrievSubType('')
        setDescription('');
        setPhoto("");
        setPdf_sign(false)
        setPdf_error_message(false)
        setPdf_size(false)
        setFileName("No file chosen")
        setGrievancePhoto({
            showGrievancePhoto: "",
            sendGrievancePhotoFile: "",
            showGrievancePhotoBase64: ""
        });
    }

    const handleInputChange = (e) => {
        const input = e.target.value;
        const words = input.trim().split(/\s+/);
        const count = words.filter((word) => word).length;

        if (count <= 50) {
            setRemarks(input);
            setWordCount(count);
            setLimitReached(false);
        } else {
            setLimitReached(true);
        }
    };

    const goBack = (e) => {
        setGrievanceResponse(false);
        setListCurrentPage(currentPage)
    }

    return (
        <div>

            <div className="p-4 f12">
                <div className="p-3 bg-blue ">
                    <h5 className="text-white">
                        {commonLabels.GRIEVANCE.GRIEVANCE_INFO} : {commonHILabels.GRIEVANCE.GRIEVANCE_INFO}
                    </h5>
                </div>
                <div className="row mt-2">
                    <div className=" d-flex pt-4 col-md-12">
                        <h5 className="bottom-dotted-line align-left p-1 col-md-12" >
                            {commonLabels.GRIEVANCE.GRIEVANCE_DETAILS}: {commonHILabels.GRIEVANCE.GRIEVANCE_DETAILS}
                        </h5>
                    </div>
                </div>
                <div className="col-md-12">
                    {/* <GrievanceTable userMobile={userMobile} /> */}
                    <div className="row">
                        <div className="col-md-12 ">
                            <form id="grievance_form" className="" encType="multipart/form-data" onSubmit={handleSubmit(handleSendRemark(singleGrievanceDetail.id, remarks, setGrievanceResponse))}>
                                <label>{commonLabels.GRIEVANCE_LABELS.GRIEVANCE_FORM_LINE}</label>
                                <input hidden="true" name="email" value={userEmail} />
                                <input hidden="true" name="mobile" value={userMobile} />
                                <div className="row">
                                    {/* Advertisement Name start .. Make chnage if need*/}

                                    <div className="col-md-4">
                                        <label className="LeftText f11">
                                            {commonLabels.GRIEVANCE_LABELS.GRIEVANCE_TOKEN}
                                        </label>
                                        <div className="input-group bg-color griev_desc_input_mob_email">
                                            <input
                                                type="text"
                                                className="form-control bg-color griev_cursor"
                                                id="ticketNumber"
                                                name="ticketNumber"
                                                placeholder={commonLabels.GRIEVANCE_LABELS.GRIEVANCE_TOKEN}
                                                autoComplete="off"
                                                value={singleGrievanceDetail.ticketNumber ? singleGrievanceDetail.ticketNumber : "No Grievance Id found"}
                                                onChange={handleInputChange}
                                                disabled
                                            />
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <label className="LeftText f11">
                                            {commonLabels.GRIEVANCE_LABELS.GRIEVANCE_TOKEN_SUBMITTED_AT}
                                        </label>
                                        <div className="input-group bg-color griev_desc_input_mob_email">
                                            <input
                                                type="text"
                                                className="form-control bg-color griev_cursor"
                                                id="createdAt"
                                                name="createdAt"
                                                placeholder={commonLabels.GRIEVANCE_LABELS.GRIEVANCE_TOKEN_SUBMITTED_AT}
                                                autoComplete="off"
                                                value={singleGrievanceDetail.createdAt ? formatToDDMMYYYY_HHMMSS(singleGrievanceDetail.createdAt) : "No Submitted date and time found"}
                                                onChange={handleInputChange}
                                                disabled
                                            />
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <label className="LeftText f11">
                                            {commonLabels.GRIEVANCE_LABELS.GRIEVANCE_CANDIDATE_EMAIL}
                                        </label>
                                        <div className="input-group bg-color griev_desc_input_mob_email">
                                            <input
                                                type="text"
                                                className="form-control bg-color griev_cursor"
                                                id="email"
                                                name="email"
                                                placeholder={commonLabels.GRIEVANCE_LABELS.GRIEVANCE_DESCRIPTION_PLACEHOLDER}
                                                autoComplete="off"
                                                value={singleGrievanceDetail.email ? singleGrievanceDetail.email : "Guest Candidate"}
                                                onChange={handleInputChange}
                                                disabled
                                            />
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <label className="LeftText f11">
                                            {commonLabels.GRIEVANCE_LABELS.GRIEVANCE_CANDIDATE_MOBILE}
                                        </label>
                                        <div className="input-group bg-color griev_desc_input_mob_email">
                                            <input
                                                type="text"
                                                className="form-control bg-color griev_cursor"
                                                id="mobile"
                                                name="mobile"
                                                placeholder={commonLabels.GRIEVANCE_LABELS.GRIEVANCE_DESCRIPTION_PLACEHOLDER}
                                                autoComplete="off"
                                                value={singleGrievanceDetail.mobile ? singleGrievanceDetail.mobile : "Guest Candidate"}
                                                onChange={handleInputChange}
                                                disabled
                                            />
                                        </div>
                                    </div>
                                    <div className="col-md-8">
                                        <label className="LeftText f11">
                                            {commonLabels.GRIEVANCE_LABELS.GRIEVANCE_ADVERTISEMENT}
                                            <span className="errorText">* </span>
                                        </label>

                                        <div className="input-group bg-color">
                                            <select
                                                value={singleGrievanceDetail.advtNumber}
                                                className="form-select  bg-color griev_cursor"
                                                name="advtType"
                                                // ref={register({ required: true })}
                                                onInput={(e) => setAdvtType(e.target.value)}
                                                disabled

                                            >
                                                <option key={0} value="">
                                                    {commonLabels.SIGN_UP.SELECT}
                                                </option>
                                                {advertisementDropdown.map((ele, ind) => {
                                                    return (
                                                        <option key={ind++} value={ele.advertisementNo + "/" + ele.year + "/" + ele.name}>
                                                            {ele.advertisementNo + " / " + ele.year + " - " + ele.name}
                                                        </option>
                                                    );
                                                })}
                                            </select>
                                        </div>

                                        {/* {_.get("advtType.type", errors) === "required" && (
                                            <p className="errorText">
                                                {commonLabels.VALIDATE_MESSAGE.FIELD_REQ}
                                            </p>
                                        )} */}
                                    </div>
                                    {/* .Advertisement End Here */}
                                    {/* Grievance Type starts Here */}
                                    <div className="col-md-4">
                                        <label className="LeftText f11">
                                            {commonLabels.GRIEVANCE_LABELS.GRIEVANCE_TYPE}
                                            <span className="errorText">* </span>
                                        </label>

                                        <div className="input-group bg-color">
                                            <select
                                                value={singleGrievanceDetail.type}
                                                className="form-select  bg-color griev_cursor"
                                                name="type"
                                                // ref={register({ required: true })}
                                                onInput={(e) => setType(e.target.value)}
                                                disabled
                                            >
                                                <option key={0} value="">
                                                    {commonLabels.SIGN_UP.SELECT}
                                                </option>
                                                {grievanceTypes?.map((ele, ind) => {
                                                    return (
                                                        <option key={ind++} value={ele.id}>
                                                            {ele.label !== null && ele.label}
                                                        </option>
                                                    );
                                                })}
                                            </select>
                                        </div>
                                    </div>

                                    {/* Grievance Type Ends Here */}


                                    {/* Grievance Sub Type Starts Here */}

                                    <div className="col-md-4">

                                        <label className="LeftText f11">
                                            {commonLabels.GRIEVANCE_LABELS.GRIEVANCE_SUB_TYPE}
                                            {/* <span className="errorText">* </span> */}
                                        </label>

                                        <div className="input-group bg-color">
                                            <select
                                                value={singleGrievanceDetail.subType}
                                                className="form-select bg-color griev_cursor"
                                                name="grievSubType"
                                                // ref={register({ required: true })}
                                                onInput={(e) => setGrievSubType(e.target.value)}
                                                disabled
                                            >
                                                <option key={0} value="">
                                                    {commonLabels.SIGN_UP.SELECT}
                                                </option>
                                                {sub_grievance_type_list.map((ele, ind) => {
                                                    return (
                                                        <option key={ind++} value={ele.id}>
                                                            {ele.label !== null && ele.label}
                                                        </option>
                                                    );
                                                })}
                                            </select>
                                        </div>
                                    </div>
                                    {/* Grievance Sub Type Ends Here */}

                                    <div className="col-md-4">
                                        <label className="LeftText f11">
                                            {commonLabels.GRIEVANCE_LABELS.GRIEVANCE_DOCUMENT}
                                        </label>
                                        {/* <div className="input-group bg-color col-md-3">
                                                <input
                                                    type="file"
                                                    className="form-control griev_cursor"
                                                    id="photo"
                                                    name="photo"
                                                    autoComplete="off"
                                                    accept=".pdf"
                                                    onChange={(e) => {
                                                        setPhoto(e.target.files[0])
                                                        onChangeImage(e);
                                                    }}
                                                    disabled

                                                />
                                            </div> */}
                                        {/* <p>Selected File: {singleGrievanceDetail?.filePath}</p> */}
                                        <br />
                                        <br />
                                        {singleGrievanceDetail.documentData ? <p className=""> {commonLabels.GRIEVANCE_LABELS.VIEW_GRIEVANCE_DOCUMENT} <span>
                                            {(singleGrievanceDetail.documentData || singleGrievanceDetail.documentData) && (
                                                <button
                                                    onClick={() => handlePdfView(singleGrievanceDetail.documentData)}
                                                    title="View PDF"
                                                    style={{
                                                        background: "none",
                                                        border: "none",
                                                        padding: "0",
                                                        cursor: "pointer",
                                                    }}
                                                >{singleGrievanceDetail.documentData ? <BsFiletypePdf
                                                    className="errorText"
                                                    size={30}
                                                    style={{ cursor: "pointer" }}
                                                /> : "No Doucument"}

                                                </button>
                                            )}
                                        </span></p>
                                            : <span className="text-danger" > {commonLabels.SIGN_UP.NO_DOCUMENT_FOUND} </span>}
                                        {/* {pdf_error_message && (
                                                <p className="errorText">
                                                    {commonLabels.VALIDATE_MESSAGE.DOCUMENT_FORMAT_WARNING}
                                                </p>
                                            )}
                                            {pdf_sign && (
                                                <p className="errorText">
                                                    {commonLabels.VALIDATE_MESSAGE.DOCUMENT_SIGN_WARNING}
                                                </p>
                                            )}
                                            {pdf_size && (
                                                <p className="errorText">
                                                    {commonLabels.COMMON.DOCUMENT_SIZE_NOTE}
                                                </p>
                                            )}
                                            {(grievancePhoto.showGrievancePhoto || grievancePhoto.showGrievancePhotoBase64) && (
                                                <p className="successText">
                                                    {commonLabels.COMMON.DOCUMENT_SAVE_NOTE}
                                                </p>
                                            )} */}


                                    </div>

                                    <div className="col-md-12">
                                        <label className="LeftText f11">
                                            {commonLabels.GRIEVANCE_LABELS.GRIEVANCE_DESCRIPTION}
                                        </label>

                                        <div className="input-group bg-color griev_desc_input ">
                                            <textarea
                                                type="text"
                                                className="form-control bg-color griev_cursor"
                                                id="description"
                                                name="description"
                                                rows={10}
                                                placeholder={commonLabels.GRIEVANCE_LABELS.GRIEVANCE_DESCRIPTION_PLACEHOLDER}
                                                autoComplete="off"
                                                value={singleGrievanceDetail.description}
                                                onChange={handleInputChange}
                                                disabled
                                            ></textarea>
                                        </div>

                                        {/* <p className="desc_words" >
                                            <span className="successText">Words: {wordCount}/50</span>
                                            {limitReached && (
                                                <span className="errorText">
                                                    You have reached the limit!
                                                </span>
                                            )}
                                        </p> */}
                                    </div>
                                    {/* <div className="griev_doc_div col-md-12"> */}
                                    {/* <div className="col-md-4 mt-4 griev_button">
                                            <button type="submit" className=" btn btn-primary custom_button  me-2 p-1 griev_button_save" disabled={pdf_error_message || pdf_size || pdf_sign} >{commonLabels.BUTTONS.SAVE}</button>
                                            <button onClick={clearGrievance} type="reset" className="btn btn-secondary p-1 griev_button_cancel" >{commonLabels.BUTTONS.CANCEL}</button>
                                        </div> */}
                                    <div className="col-md-12">
                                        <label className="LeftText f11">
                                            {commonLabels.GRIEVANCE_LABELS.GRIEVANCE_REMARKS_DESCRIPTION}
                                        </label>

                                        <div className="input-group bg-color griev_desc_input">
                                            <textarea
                                                type="text"
                                                className="form-control"
                                                id="remarks"
                                                name="remarks"
                                                rows={10}
                                                placeholder={commonLabels.GRIEVANCE_LABELS.GRIEVANCE_REMARKS_DESCRIPTION_PLACEHOLDER}
                                                autoComplete="off"
                                                value={remarks}
                                                onChange={handleInputChange}
                                            ></textarea>
                                        </div>

                                        <p className="desc_words" >
                                            <span className="successText">Words: {wordCount}/50</span>
                                            {limitReached && (
                                                <span className="errorText">
                                                    You have reached the limit!
                                                </span>
                                            )}
                                        </p>
                                    </div>
                                    {/* </div> */}
                                    {/* <button className="  btn btn-primary custom_button  col-8 center-div" > Send Response </button> */}
                                    <div className="col-md-12 mt-4 griev_button">
                                        <button type="submit" className=" btn btn-primary custom_button  me-2  " >{commonLabels.BUTTONS.REPLY}</button>
                                        <button type="reset" className="btn btn-secondary" onClick={goBack} > {commonLabels.BUTTONS.BACK}</button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div >
        </div >

    );
}

export default GrievanceResponseForm;
